export default __webpack_public_path__ + "static/media/Hockey_05.dc78f843.png";